<template>
  <div class="orderBox">
    <div class="form-title">受益人</div>
    <FormItem prop="beneficiaryType" label="受益人类型" :rules="$units.formRule.required('请选择')">
      <span v-if="disabled">{{ parent.beneficiaryType | filterBeneficiaryType }}</span>
      <Select v-else v-model="parent.beneficiaryType" filterable transfer clearable>
        <Option v-for="(txt, value) in $dic.beneficaryTypes" :value="value" :key="value">{{ txt }}</Option>
      </Select>
    </FormItem>

    <template v-if="parent.beneficiaryType == 2">
      <div class="info" v-for="(formItem, i) in formData" :key="i">
        <FormItem :prop="formKey + '.' + i + '.benefitRatio'" label="受益比例(%)" :rules="$units.formRule.required('请输入1-100的整数')">
          <span v-if="disabled">{{ formItem.benefitRatio }}</span>
          <Input v-else type="text" v-model="formItem.benefitRatio" placeholder="请输入1-100的整数" />
        </FormItem>
        <FormItem :prop="formKey + '.' + i + '.relation'" label="与受保人关系" :rules="$units.formRule.required('请选择')">
          <lzDicTxt v-if="disabled" dicType="RELATION" :dicCode="formItem.relation"></lzDicTxt>
          <Select v-else v-model="formItem.relation" filterable transfer clearable>
            <Option v-for="(txt, value) in RELATION" :value="value" :key="value">{{ txt }}</Option>
          </Select>
        </FormItem>
        <person :formData="formItem" :formKey="formKey + '[' + i + ']'" :disabled="disabled"></person>
        <div class="bar"></div>
      </div>

      <FormItem>
        <div class="editBtn">
          <Button type="dashed" long icon="md-add" @click="add">添加受益人</Button>
          <Button v-if="formData.length > 1" type="dashed" long @click="del">删除受益人</Button>
        </div>
      </FormItem>
    </template>
  </div>
</template>

<script>
import person from "./person";
import lzDicTxt from '@/components/commons/lzDicTxt';
export default {
  props: {
    disabled: {},
    parent: {
      default() {
        return {};
      }
    },
    formData: {
      default() {
        return [];
      }
    },
    formKey: {}
  },
  components: { person, lzDicTxt },
  data() {
    return {
      RELATION: JSON.parse(localStorage.dic)['RELATION'], // 关系
    };
  },
  watch: {},
  computed: {},
  created() {
  },
  mounted() { },
  methods: {
    add() {
      this.formData.push({});
    },
    del() {
      this.formData.pop();
    }
  }
};
</script>
<style lang="scss" scoped>
.editBtn {
  display: flex;
}

.bar {
  border-bottom: 1px solid #ececec;
  margin-bottom: 30px;
}
</style>
